
import React, { Component } from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { translate } from 'react-i18next'

import {withStyles} from '@material-ui/core/styles'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import TextField from '@material-ui/core/TextField'
import CheckCircle from '@material-ui/icons/CheckCircle'
import Warning from '@material-ui/icons/Warning'

import * as actions from '../../../actionTypes'
import WarningPaper from "../../common/WarningPaper";

const styles = theme => ({
  adjustedWidth: {width: '75%'},
  sessionWarning: {
    marginBottom: theme.spacing.unit * 5,
    width: '75%'
  },
  commentCheckCircle: {
    color: '#5da9d8',
    float: 'left',
    fontSize: 35,
    marginRight: theme.spacing.unit * 1.5
  },
  commentWarningIcon: {
    color: '#a94442',
    float: 'left',
    fontSize: 35,
    marginRight: theme.spacing.unit * 1.5
  },
  warningHeader: {
    border: '1px #a94442 solid',
    background: '#fcf8e3',
    marginBottom: theme.spacing.unit * 3,
    width: '75%'
  },
  paddingBottom: {
    paddingBottom: theme.spacing.unit * 3
  }
})

class CommentsContainer extends Component {
  constructor(props) {
    super(props)
    this.state = {
      counselorComments: this.props.counselorComments
    }

    this.props.navigator.setIsForwardButtonHidden(props.isComplete)
    this.props.navigator.setForwardButtonLabel('Complete')
  }

  addCounselorComments(event) {
    this.props.addCounselorComments(event.target.value)
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      counselorComments: nextProps.counselorComments
    })
  }

  componentWillUnmount() {
    this.props.navigator.resetNavigationVisibilityAndLabel()
  }

  handleChange(event) {
    this.setState({counselorComments: event.target.value})
  }

  render() {
    const { classes, isComplete, t } = this.props

    return (
      <Grid
        alignContent="flex-start"
        className="counseling-session-page-container"
        container
        justify="center"
        spacing={16}
      >
        <Grid item xs={10}>
          <Typography className={isComplete ? classes.paddingBottom : ''} variant="headline">
            {t('Comments')}
          </Typography>
        </Grid>

        {!isComplete ? (
          <React.Fragment>
            <WarningPaper
              classes={{root: classes.warningHeader}}
              icon={<Warning className={classes.commentWarningIcon}/>}
            >
              <Typography component="p">
                {t('Once Session Complete')}
              </Typography>
            </WarningPaper>
            <WarningPaper
              classes={{root: classes.sessionWarning}}
              icon={<CheckCircle className={classes.commentCheckCircle}/>}
            >
              <Typography component="p">
                {t('Session Almost Complete')}
              </Typography>
            </WarningPaper>
          </React.Fragment>
        ) : (
          <WarningPaper
            classes={{root: classes.sessionWarning}}
            icon={<CheckCircle className={classes.commentCheckCircle}/>}
          >
            <Typography component="p">
              {t('Session Is Complete')}
            </Typography>
          </WarningPaper>
        )}

        <TextField
          className={classes.adjustedWidth}
          id="counselorComments"
          multiline
          name="counselorComments"
          onBlur={this.addCounselorComments.bind(this)}
          onChange={this.handleChange.bind(this)}
          placeholder={t('Enter Any Feedback')}
          value={this.state.counselorComments}
        />
      </Grid>
    )
  }
}

const mapStateToProps = state => ({
  counselorComments: state.counselingSession.counselingSessionData.counselorComments,
  isComplete: state.counselingSession.counselingSessionData.isComplete
})

const mapDispatchToProps = dispatch => ({
  addCounselorComments(comments) {
    const action = {type: actions.ADD_COUNSELOR_COMMENTS, payload: {comments}}
    dispatch(action)
  },
})

export default compose(
  translate(),
  connect(mapStateToProps, mapDispatchToProps),
  withStyles(styles)
)(CommentsContainer)


// WEBPACK FOOTER //
// ./src/components/counseling-session/comments/CommentsContainer.js